import { AppIcons, AppIcon, ICON_SIZES } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { Avatar, Box, Chip, Theme, SxProps } from '@mui/material';

export type SponsorChipProps = Readonly<{
  label: string;
  iconImage?: string;
  defaultIcon: AppIcons;
}>;

export const SponsorChip = ({ label, iconImage, defaultIcon }: SponsorChipProps) => {
  return (
    <Chip
      variant="badge"
      label={label}
      size="md"
      icon={
        iconImage ? (
          <Avatar sx={iconImageSx} src={iconImage} alt="Profile Picture" />
        ) : (
          <Box sx={defaultIconSx}>
            <AppIcon
              iconName={defaultIcon}
              diameter={ICON_SIZES['12px']}
              color={'Colors/Foreground/fg-quaternary'}
            />
          </Box>
        )
      }
      sx={chipSx}
      type="leading"
    />
  );
};

const chipSx: SxProps<Theme> = ({ backrs, typography }) => ({
  backgroundColor: backrs.colors['Colors/Base/White'],
  width: 'fit-content',
  maxWidth: '200px', // Set a reasonable max width to prevent overflow
  border: `1px solid ${backrs.colors['Gray/700']}`,
  '& .MuiChip-icon': {
    marginLeft: backrs.spacing['spacing-none'],
    marginRight: backrs.spacing['spacing-none'],
    border: 'unset',
  },
  '& .MuiChip-label': {
    ...typography['text-sm-regular'],
    color: backrs.colors['Gray/700'],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
});

const iconImageSx: SxProps<Theme> = ({ backrs }) =>
  ({
    width: '16px',
    height: '16px',
    border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  }) as const;

const defaultIconSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: backrs.radius['radius-full'],
  padding: backrs.spacing['spacing-xxs'],
  border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
});
